<template>
  <div>
    <div v-for="name in pluginName" :key="name">
      <div v-if="hasComponent(name)">
        <component :is="name + type" v-bind="$attrs" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      required: true
    },
    isBigScreenComponent: {
      type: Boolean,
      default: false
    },
    pluginName: {
      type: [Array, undefined],
      default: () => []
    },
    componentName: {
      type: String,
      required: true
    }
  },
  methods: {
    hasComponent(name) {
      let status = true
      try {
        const component = require(`components/toolbar-option-components/${
          this.isBigScreenComponent ? "bigScreen/" : ""
        }${this.componentName}/plugin/${name}/${name}${this.type}.vue`).default
        this.$options.components[name + this.type] = component
      } catch (error) {
        status = false
      }
      if (!status) {
        try {
          const component = require(`materials/${
            this.isBigScreenComponent ? "bigScreen/" : ""
          }${this.componentName}/toolbars/plugin/${name}/${name}${this.type}.vue`).default
          this.$options.components[name + this.type] = component
          status = true
        } catch (err) {
          console.log("err", err)
          status = false
        }
      }
      return status
    }
  }
}
</script>
